import { useContext } from 'react';
import { currentDomain as domain } from '../../services/Util';
import Edition from '../../services/Edition';
import {
	Twitter as TwitterIcon,
	Facebook as FacebookIcon,
	Email as EmailIcon,
} from './Socials/icons/solid';
// import * as IconsOutline from './Socials/icons/outline/index';
// import * as IconsSolid from './Socials/icons/solid/index';
import styled from 'styled-components';

const StyledButtons = styled.div`
	padding-bottom: 1rem;

	.btn {
		background: rgb(${(props) => props.textColor || '0,0,0'});
		border-color: rgb(${(props) => props.backgroundColor || '256, 256, 256'}) !important;
		svg {
			fill: rgb(${(props) => props.backgroundColor || '256, 256, 256'}) !important;
		}
	}
`;

export default function ShareButtons({ slug, iconStyle, position, backgroundColor, textColor }) {
	const { __ } = wp.i18n;

	if (Edition.isDefault || 0 === position.length) {
		return false;
	}

	return (
		<StyledButtons
			id="slp-share-buttons"
			backgroundColor={backgroundColor}
			textColor={textColor}
			className={`btn-group${'right' === position || 'left' === position ? '-vertical' : ''}`}
			position={position}
		>
			<a
				className="btn"
				href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
					domain + '/' + slug,
				)}&text=${encodeURIComponent(__('Check out my page:', 'social-link-pages') + ' ')}`}
				target="_blank"
			>
				<TwitterIcon />
			</a>
			<a
				className="btn"
				href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
					domain + '/' + slug,
				)}`}
				target="_blank"
			>
				<FacebookIcon />
			</a>
			<a
				className="btn"
				href={`mailto:?subject=${encodeURIComponent(
					__('Check out my page:', 'social-link-pages'),
				)}&body=${encodeURIComponent(domain + '/' + slug)}`}
				target="_blank"
			>
				<EmailIcon />
			</a>
		</StyledButtons>
	);
}
